import copy from 'copy-to-clipboard'

import Link from '@atoms/Link'
import { useToast } from '@molecules/Toast'
import SnsIcon from '@icons/Sns'
import { useTranslation } from '@models/Translation'
import { buildUtmParam } from '@models/Util'

import * as style from './style.module.sass'

type ShareButtonProps = {
  name: 'x' | 'facebook' | 'line' | 'clipboard' | 'linkedin'
  type?: 'normal' | 'circle' | 'bigCircle'
  text?: string
}
const ShareButton = ({ name, type = 'normal', text }: ShareButtonProps) => {
  const { locale, path, t } = useTranslation()
  const shareUrl = `https://fashiontechnews.zozo.com${
    locale === 'ja' ? '' : '/en'
  }${path}?${buildUtmParam({ source: name, medium: 'social', campaign: 'article_share' })}`
  const encodedText = text === undefined ? '' : encodeURIComponent(text)
  const encodedUrl = encodeURIComponent(shareUrl)
  const { show, Toast } = useToast(t('share.copy'))

  const buildUrl = () => {
    switch (name) {
      case 'x':
        return `https://x.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`
      case 'facebook':
        return `https://www.facebook.com/share.php?u=${encodedUrl}`
      case 'line':
        return `https://social-plugins.line.me/lineit/share?url=${encodedUrl}`
      case 'linkedin':
        return `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`
      default:
        throw new Error('Invalid name')
    }
  }

  const clickClipboard = () => {
    copy(shareUrl)
    show()
  }

  if (name === 'clipboard') {
    return (
      <div className={style.buttonContainer}>
        <button onClick={clickClipboard} className={style.share}>
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            data-type={type}
          >
            <circle cx="12.7969" cy="12" r="12" fill="#828282" />
            <path
              d="M13.8916 10.903C12.9543 9.96572 11.4347 9.96572 10.4975 10.903L8.09747 13.303C7.16022 14.2402 7.16022 15.7598 8.09747 16.6971C9.03473 17.6344 10.5543 17.6344 11.4916 16.6971L12.1525 16.0362M11.6975 13.0971C12.6347 14.0344 14.1543 14.0344 15.0916 13.0971L17.4916 10.6971C18.4288 9.75983 18.4288 8.24024 17.4916 7.30298C16.5543 6.36572 15.0347 6.36572 14.0975 7.30298L13.4377 7.96275"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        {Toast}
      </div>
    )
  }

  return (
    <Link className={style.share} to={buildUrl()}>
      <SnsIcon name={name} type={type} />
    </Link>
  )
}

export default ShareButton
